import { cn } from '@/lib/utils'

interface CountdownBadgeProps {
  dateIso: string | null
}

export function CountdownBadge({ dateIso }: CountdownBadgeProps) {
  if (!dateIso) {
    return <span className="text-meta">—</span>
  }

  const target = new Date(dateIso)
  const now = new Date()
  // Reset to start of day for consistent day counting
  const targetDay = new Date(target.getFullYear(), target.getMonth(), target.getDate())
  const nowDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const days = Math.round((targetDay.getTime() - nowDay.getTime()) / (1000 * 60 * 60 * 24))

  let label: string
  if (days < 0) {
    label = `${Math.abs(days)}d ago`
  } else if (days === 0) {
    label = 'Today'
  } else if (days === 1) {
    label = 'Tomorrow'
  } else {
    label = `${days} days`
  }

  const color =
    days < 0
      ? 'text-muted-foreground'
      : days < 7
        ? 'text-[hsl(var(--destructive))]'
        : days < 14
          ? 'text-[hsl(var(--status-warning))]'
          : 'text-[hsl(var(--status-success))]'

  return <span className={cn('text-xs font-medium', color)}>{label}</span>
}
